import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import View from '@loggi/ui/components/view';
import Icon from '@loggi/ui/components/icon';
import Spinner from '@loggi/ui/components/spinner';
import colors from '@loggi/ui/components/utils/colors';
import { deprecated } from '@loggi/ui/components/utils/warnings';
const { getLabelElement } = __NATIVE__ ? require('./native') : require('./dom');

import {
  COLOR_TYPES,
  SHAPE_TYPES,
  ROUNDED_SHAPE,
  CIRCLE_SHAPE,
  ICONS,
  CONTENT_ALIGN_CENTER,
  ALIGN_TYPES,
  CIRLE_SHAPE_SIZES
} from './types';

function deprecatedPropWarnings(props) {
  if (__DEV__) {
    const boundDeprecated = deprecated.bind(this, 'Label');

    if (props.circle) {
      boundDeprecated('circle', 'shape="circle"');
    }
    if (props.rounded) {
      boundDeprecated('rounded', 'shape="rounded" or nothing');
    }
    if (props.children) {
      /* eslint-disable */
      console.warn(
        '[ELKE] Component Label: Children usage are deprecated, please use value=[your string value], ' +
          'or read https://elke.loggi.com/components/label for more information'
      );
      /* eslint-enable */
      // its a custom message, not a single replace
    }
  }
}

function Label(props) {
  deprecatedPropWarnings(props);

  const {
    className,
    color,
    circle,
    rounded,
    children,
    value,
    shape,
    block,
    isLoading,
    icon,
    isDisabled,
    contentAlign,
    size
  } = props;

  const labelClasses = [
    'label',
    { 'label-block': block && shape !== CIRCLE_SHAPE },
    { [`label-${shape}`]: shape },
    { 'label-disabled': isDisabled },
    { 'label-align-left': contentAlign === 'left' },
    { [`label-${color}`]: color },
    { [`label-circle-${size}`]: circle || shape === CIRCLE_SHAPE },
    { 'label-rounded': rounded },
    className
  ];

  const spinnerColor =
    color === colors.type.WARNING ? colors.type.DARKEST : colors.type.WHITE;

  const inlineContent = value ? [value] : children;

  const content = isLoading
    ? [
        <Spinner
          key="loading"
          className={value ? 'label-spinner' : null}
          color={spinnerColor}
        />,
        value
      ]
    : icon
    ? [
        <Icon key={icon} className={value ? 'label-icon' : null} type={icon} />,
        value
      ]
    : inlineContent;

  return getLabelElement(content, labelClasses, props);
}

Label.displayName = 'Label';
Label.propTypes = {
  value: PropTypes.string,
  color: PropTypes.oneOf(COLOR_TYPES),
  shape: PropTypes.oneOf(SHAPE_TYPES),
  block: PropTypes.bool,
  isLoading: PropTypes.bool,
  icon: PropTypes.oneOf(ICONS),
  isDisabled: PropTypes.bool,
  contentAlign: PropTypes.oneOf(ALIGN_TYPES),
  className: PropTypes.string,
  circle: PropTypes.bool,
  rounded: PropTypes.bool,
  size: PropTypes.oneOf(CIRLE_SHAPE_SIZES)
};

Label.defaultProps = {
  value: null,
  color: colors.type.INFO,
  shape: ROUNDED_SHAPE,
  block: false,
  isLoading: false,
  icon: null,
  isDisabled: false,
  contentAlign: CONTENT_ALIGN_CENTER,
  rounded: false,
  circle: false,
  size: 'small'
};

export default Label;
